import * as Yup from "yup";
import { TFunction } from "i18next";

type Translator = (key: string, vars?: Record<string, any>) => string;

export default function savePayRateSchema(t: TFunction | Translator) {

  return Yup.object().shape({
  
    payrate_start_date: Yup.date()
      .required(
        t("Rate.validations.required", {
          value: t("Rate.start_date"),
        })
      )
      .test(
        "is-sunday",
        t("Rate.validations.mustBeSunday", { value: t("Rate.start_date") }),
        (value) => value && new Date(value).getDay() === 0 // 0 = Sunday
      ),

    payrate_type: Yup.string()
    .required(
      t("Rate.validations.required", {
        value: t("Rate.type"),
      })
    ),

    // payrate_value: Yup.number()
    //   .required(
    //     t("Rate.validations.required", {
    //       value: t("Rate.rate"),
    //     })
    //   ).min(1, t("Rate.validations.decimalNum", {
    //     value: t("Rate.rate"),
    //   })),
  });
}